// T076 — Shared EmptyState component. Replaces the per-page "no X yet"
// flat-text empty states with a single component that supports a primary
// CTA + a secondary link, so the operator always has a next action when
// a list is empty (vs. just a tombstone message).
//
// Usage:
//   <EmptyState
//     title="No matches"
//     body="Try widening your target roles."
//     actions={[
//       { label: 'Scan now', onClick: () => triggerScan(), primary: true },
//       { label: 'Edit preferences', to: '/profile' },
//     ]}
//   />
//
// Each action is either a button (onClick) or a router link (to). The
// first action gets the brand-500 primary treatment by default; set
// `primary: false` to override.

import Button from './ui/Button.jsx';

export default function EmptyState({ title, body, actions = [], icon = '◌' }) {
  return (
    <div className="mt-3 rounded-xl border border-dashed border-slate-800 bg-slate-900/30 p-6 text-center">
      {icon && <p className="mb-2 text-2xl text-slate-700" aria-hidden="true">{icon}</p>}
      <p className="text-sm font-medium text-slate-300">{title}</p>
      {body && <p className="mt-1 text-xs text-slate-500">{body}</p>}
      {actions.length > 0 && (
        <div className="mt-4 flex flex-wrap items-center justify-center gap-2">
          {actions.map((a, i) =>
            a.to ? (
              <Button key={i} size="sm" variant={(a.primary ?? i === 0) ? 'primary' : 'secondary'} to={a.to}>
                {a.label}
              </Button>
            ) : (
              <Button
                key={i}
                size="sm"
                variant={(a.primary ?? i === 0) ? 'primary' : 'secondary'}
                onClick={a.onClick}
                disabled={a.disabled}
              >
                {a.label}
              </Button>
            ),
          )}
        </div>
      )}
    </div>
  );
}
